<div class="toggle-container">
  <mat-slide-toggle 
    [(ngModel)]="question.answer!.value" 
    (change)="change()"
    [color]="'primary'"
    class="custom-toggle"
    aria-label="Toggle option">
  </mat-slide-toggle>
</div>

